module.exports = "/_next/static/images/GDGPune2023-92f059ebaaba3b7c3f4fbba4ad1f9078.jpg";